import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { globalVariable } from 'src/app/globalVariable/globalvariable';
import { CommonService } from 'src/app/services/common.service';
import { saveAs } from 'file-saver';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { interval } from 'rxjs';
import { PopupimmudbcontentComponent } from '../popupimmudbcontent/popupimmudbcontent.component';
import { ActivatedRoute } from '@angular/router';
import { param } from 'jquery';

@Component({
  selector: 'app-landingpageoutsidelogin',
  templateUrl: './landingpageoutsidelogin.component.html',
  styleUrls: ['./landingpageoutsidelogin.component.scss']
})
export class LandingpageoutsideloginComponent implements OnInit {
  selectedIndexVal: any
  htmlContent: string | null = null;
  blobUrl: string | null = null;
  safeurl: any;
  currentTab: string = "";
  selectedTabIndex: number = 0;
  selectedTabName: string | null = null;
  constructor(private _snackBar: MatSnackBar, private route: ActivatedRoute, private router: Router, private commonServ: CommonService, private http: HttpClient, private sanitizer: DomSanitizer, private modalService: NgbModal, public dialog: MatDialog) { }

  @ViewChild('content') popupview !: ElementRef;

  ngOnInit(): void {
    this.commonServ.callingpublickey().subscribe((val) => {
      console.log("val alert", val)
      if (val.hasOwnProperty("publicKey")) {
        const publicKeyBase64 = val['publicKey'];
        globalVariable.publickey = publicKeyBase64;
        this.getDocumentType();
      }
    });

    this.route.paramMap.subscribe(params => {
      this.selectedTabName = params.get('tabName');
      if (!this.selectedTabName) {
        this.selectedTabName = this.tabList[0];
      }
      console.log("Selected Tab Name from URL:", this.selectedTabName);
      if (this.tabList.length > 0) {
        this.setActiveTab(this.selectedTabName);
      }
    });
  }

  ngOnDestroy() {
    // Clean up Blob URL when component is destroyed
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
    }
  }

  signin() {
    this.router.navigate(["/login"]);
  }

  downloadpdffile() {
    this.commonServ.downloadpdffile(5).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      const filename = 'example.pdf';
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
    })
  }

  tabClick(event: any): void {
    const tabName = this.tabList[event.index];
    console.log("Tab Changed:", tabName);
    this.router.navigate(['/public-documents', tabName.replace(/\s/g, "").toLowerCase()]);
  }

  viewHtml() {
    const dialogRef = this.dialog.open(PopupimmudbcontentComponent, {
      width: '100%',
      disableClose: true,
      data: {
        header: '',
        doc_id: 5
      },
      panelClass: 'my-dialog',
    });
  }

  tabList: Array<string> = []

  documentsList: Array<Object> = []

  getDocumentType(): void {
    console.log("Outside trust");
    this.commonServ.fetchPublicDocumentType("Outside trust").subscribe(
      (res) => {
        console.log("res", res);
        res.forEach((element) => {
          this.tabList.push(element.lookup_code);
        });
        this.tabList.sort((a, b) => a.localeCompare(b));
        this.setActiveTab(this.selectedTabName);
      }, (err) => {
        console.log(err);
      }
    );
  }

  setActiveTab(tabName: string | null): void {
    if (!tabName) {
      this.selectedTabIndex = 0;
      return;
    }

    const tabIndex = this.tabList.findIndex(tab => tab.replace(/\s/g, "").toLowerCase() === tabName.toLowerCase());
    if (tabIndex !== -1) {
      this.selectedTabIndex = tabIndex;
    } else {
      this.selectedTabIndex = 0;
    }
    console.log("Active Tab Index:", this.selectedTabIndex);
  }

  viewdatainhtmlpage(n) {
    this.commonServ.downloadpdffile(n['doc_id']).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      const filename = n['doc_name'];
      var url = this.commonServ.fetchAndDisplayBlob(response[0].doc_contenet, filename);
      console.log("url", url)
      this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
        this.blobUrl = URL.createObjectURL(blob);
        this.safeurl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl)
      });
    })
  }

  viewdata(n) {
    console.log(n)
    const dialogRef = this.dialog.open(PopupimmudbcontentComponent, {
      width: '100%',
      disableClose: true,
      data: {
        header: '',
        alldata: n,
        doc_id: n['doc_id']
      },
      panelClass: 'my-dialog',
    });
  }

  downloaddata(n) {
    console.log(n)
    this.commonServ.downloadpdffile(n['doc_id']).subscribe((response) => {
      console.log("response", response)
      console.log("response", response)
      console.log(response[0].doc_contenet
      )
      const filename = n['doc_name'];
      this.commonServ.downloadPdfFromByteString(response[0].doc_contenet, filename);
    })
  }

  getDocumentsListFromCategory(event: any) {
    const tabName = this.tabList[event.index];
    console.log("tabchange", tabName);
    this.router.navigate(['/public-documents', tabName.replace(/\s/g, "").toLocaleLowerCase()], { relativeTo: this.route })
    this.commonServ.getPublicDocCategeryDetailsByDocType(event.tab.textLabel).subscribe(
      (res) => {
        console.log("res1", res);
        console.log("x", event.tab.textLabel);
        this.documentsList = res
      }, (err) => {
        console.log(err);
      }
    )
  }
}